import { createAction, props } from '@ngrx/store';
import {
  HydrationSources,
  IHydrationStatusStore,
} from '../interfaces/hydration-status-store.interface';
export const HYDRATION_SOURCE = '[HydrationStatus] HydrationSource';
export const ALL = '[HydrationStatus] All';

export const HydrationSourceAction = createAction(
  HYDRATION_SOURCE,
  props<{
    hydrationSource: HydrationSources;
  }>(),
);
export const AllAction = createAction(ALL, props<IHydrationStatusStore>());

export type All = ReturnType<typeof AllAction>;
